<template src="./template.html"></template>
<script>
import EventCalendar from 'components/EventCalendar'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'

export default {
  name: 'event-calendar-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    let theme = this.$route.query.theme

    //TODO: should eventually get the venue to update their code
    if (this.$route.query.venueId === 'af570dc9775899fb') {
      //NOTE: hardcode Bodega Canal to fix their widget colors
      theme = 'theme-dark'
    }

    return {
      venueId: this.$route.query.venueId,
      theme,
    }
  },
  components: {
    EventCalendar,
  },
  methods: {
    onUpdated() {
      this.publishDimensions({
        minHeight: 1000,
      })
    },
    onEventClicked(event) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.EVENT_CLICKED,
          iframeId: this.iframeId,
          data: {
            event,
            eventId: event.id,
          },
        },
        {
          parent: true,
        }
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/EventCalendar/index.vue